import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-2.5 text-xs uppercase tracking-[0.25em] font-mono2 text-cyan-400 font-semibold">
    <span className="h-px w-8 bg-gradient-to-r from-cyan-400 to-transparent" />
    {children}
  </span>
);
